import { createSlice } from '@reduxjs/toolkit'
const initialState = {
    agent:"",
    templateType:"",
    templateName:"",
    templateCategory:"",

  }

  export const RcsTemplateSlice=createSlice({
     name:'template',
     initialState,
     reducers:{
        setAgent:(state, action)=>{
           state.agent=action.payload
        },
        setTemplateType:(state, action)=>{
         state.templateType=action.payload
      },
      setTemplateName:(state,action)=>{
          state.templateName=action.payload
      },
       setTemplateCategory:(state,action)=>{
          state.templateCategory=action.payload
      },
        
     }
  })
  export const {setAgent,setTemplateType,setTemplateCategory,setTemplateName}=RcsTemplateSlice.actions;
  export default RcsTemplateSlice.reducer